import { render, staticRenderFns } from "./EnumerationField.vue?vue&type=template&id=ab258636&scoped=true"
import script from "./EnumerationField.vue?vue&type=script&lang=ts"
export * from "./EnumerationField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab258636",
  null
  
)

export default component.exports